import React, { Component } from "react";
import { connect } from "react-redux";
import LangContext, { i18n } from "modules/shared/context/langContext";
import * as actions from "../actions";
import { GeneralStyledContent } from "../../../../styled/common-styled";
import Breadcrumb from "./../../../shared/components/Breadcrumb";
import { helper_convertDateformat } from "../../../../lib/helper";
import {
  Button,
  Table,
  Form,
  Row,
  Col,
  Input,
  Tag,
  Spin,
  Modal,
  Popconfirm,
  Badge,
  Icon,
  Tooltip,
  Drawer,
  Select,
  DatePicker,
  message,
} from "antd";
import moment from "moment";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import FilterHistory from "./FilterHistory";
import history from "../../../../lib/history";
import RescheduleLog from "./RescheduleLog";

const columnStyle = { fontSize: "12px", fontWeight: "400" };

class History extends Component {
  state = {
    visible: false,
    page: 1,
    pageSize: 10,
    searchName: "",
    orderBy: "im.id",
    orderType: "desc",
    filterObj: {
      vehicle_id: this.props.match.params.id,
      maintenance_status: "",
      date_start: "",
      date_end: "",
    },

    // modal reschedule log
    rescheduleLogVisible: false,
    rescheduleLogData: [],

    process_color: {
      o: "#1890ff", // open
      s: "#1890ff", //schedule
      cf: "green", // closed fixed
      cn: "red", // closed not available
      ot: "red", // cancel
      wa: "#1890ff", // waiting assessment
      ws: "#1890ff", // waiting scheduled
      ps: "#1890ff", // pending signature
    },
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onCloseSearch = (resetForm) => {
    this.setState({
      visible: false,
    });
  };

  filterHistoryservicerepairdevice = (values) => {
    const { vehicle_id, maintenance_status, eventdate } = values;
    const date_start =
      eventdate != "" ? moment(eventdate[0]["_d"]).format("YYYY-MM-DD") : "";
    const date_end =
      eventdate != "" ? moment(eventdate[1]["_d"]).format("YYYY-MM-DD") : "";

    this.setState({
      filterObj: {
        vehicle_id: vehicle_id,
        maintenance_status: maintenance_status,
        date_start: date_start,
        date_end: date_end,
      },
    });
    this.props.loadHistoryservicerepairdevice(
      {
        page: this.state.page,
        pageSize: this.state.pageSize,
        orderBy: this.state.orderBy,
        orderType: this.state.orderType,
        filterObj: {
          vehicle_id: vehicle_id,
          maintenance_status: maintenance_status,
          date_start: date_start,
          date_end: date_end,
        },
      },
      true
    );
  };

  componentDidMount() {
    this.props.loadHistoryservicerepairdevice(this.state, true);
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      page: pagination.current,
    });

    let orderBy = "";
    let orderType = "";

    if (Object.keys(sorter).length === 0 && sorter.constructor === Object) {
      orderBy = this.state.orderBy;
      orderType = this.state.orderType;
    } else {
      this.setState({
        orderBy: sorter.columnKey,
        orderType: sorter.order == "descend" ? "desc" : "asc",
      });
      orderBy = sorter.columnKey;
      orderType = sorter.order == "descend" ? "desc" : "asc";
    }

    this.props.loadHistoryservicerepairdevice(
      {
        page: pagination.current,
        pageSize: this.state.pageSize,
        searchName: "",
        orderBy: orderBy,
        orderType: orderType,
        filterObj: {
          vehicle_id: this.state.filterObj.vehicle_id,
          maintenance_status: this.state.filterObj.maintenance_status,
          date_start: this.state.filterObj.date_start,
          date_end: this.state.filterObj.date_end,
        },
      },
      true
    );
  };

  handleOpenRescheduleLog = (data) => {
    this.setState({
      rescheduleLogVisible: true,
      rescheduleLogData: data,
    });
  };
  handleCloseRescheduleLog = () => {
    this.setState({
      rescheduleLogVisible: false,
      rescheduleLogData: [],
    });
  };

  expandedRowRender = (record, index, indent, expanded) => {
    const columns = [
      {
        title: "#",
        dataIndex: "row_number",
        key: "row_number",
        width: 50,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{index + 1}</div>,
          };
        },
      },
      {
        //สถานะ
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.m.maintenance_status}
          </LangContext.Consumer>
        ),
        dataIndex: "status_name_th",
        sorter: false,
        render(text, record, index) {
          return <span style={{ color: "red" }}>{text}</span>;
        },
        width: 120,
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.u.updatedAt}
          </LangContext.Consumer>
        ),
        key: "action_time",
        dataIndex: "action_time",
        width: 150,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.u.use_account_name}
          </LangContext.Consumer>
        ),
        key: "account_name",
        dataIndex: "account_name",
        width: 150,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];

    return (
      <div style={{ width: "600px" }}>
        <p style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}>
          <LangContext.Consumer>
            {(i18n) => {
              return (
                <div>{`${i18n.d.documentNumber}: ${record.document_number ||
                  "-"}`}</div>
              );
            }}
          </LangContext.Consumer>
        </p>
        <Table
          size="small"
          columns={columns}
          dataSource={record.change_status_detail || []}
          pagination={false}
          style={{ padding: 20 }}
          bordered
        />
      </div>
    );
  };

  render() {
    let self = this;
    const columns = [
      {
        title: "#",
        dataIndex: "row_number",
        key: "row_number",
        width: 50,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.v.vehicle}
          </LangContext.Consumer>
        ),
        key: "v.plate_no",
        dataIndex: "plate_no",
        width: 300,
        // sorter: true,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>{`${record.plate_no || "-"} (${record.code || "-"})`}</div>
            ),
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.d.documentNumber}
          </LangContext.Consumer>
        ),
        key: "im.id",
        dataIndex: "document_number",
        width: 150,
        sorter: true,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{`${record.document_number || "-"}`}</div>,
          };
        },
      },
      {
        //ประเภทการแจ้งซ่อม
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.m.maintenance_type}
          </LangContext.Consumer>
        ),
        key: "type_name_th",
        dataIndex: "type_name_th",
        width: 120,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          // วันเวลาที่แจ้งซ่อม
          <LangContext.Consumer>
            {(i18n) => i18n.m.maintenanceDeviceReceiveDate}
          </LangContext.Consumer>
        ),
        key: "receive_date",
        dataIndex: "receive_date",
        sorter: true,
        width: 130,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          // วันเวลาที่นัดหมาย
          <LangContext.Consumer>
            {(i18n) => i18n.a.appointment_date}
          </LangContext.Consumer>
        ),
        key: "appointment_date",
        dataIndex: "appointment_date",
        sorter: true,
        width: 150,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        //สถานะ
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.m.maintenance_status}
          </LangContext.Consumer>
        ),
        dataIndex: "",
        sorter: false,
        render(text, record, index) {
          let message = "";
          let link_path = "";
          let link_check = false;
          let color_message = "";
          if (record.lost_device == 0) {
            if (record.device_code != "-") {
              if (record.process_type === null) {
                message = "-";
                color_message = "black";
              } else {
                message = record.status_name_th;
                color_message =
                  self.state.process_color[record.process_type.toLowerCase()];
              }
            } else {
              message = "ยังไม่ได้ติดตั้ง";
              color_message = "red";
            }
          } else if (record.online == 0) {
            message = "อุปกรณ์หาย";
            color_message = "red";
          }

          return {
            props: {
              style: columnStyle,
            },

            children: <span style={{ color: color_message }}>{message}</span>,
          };
        },
        width: 100,
      },
      {
        title: (
          // อาการของปัญหา
          <LangContext.Consumer>
            {(i18n) => i18n.t.type_problem}
          </LangContext.Consumer>
        ),
        key: "type_problem",
        dataIndex: "type_problem",
        sorter: false,
        width: 300,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>
                {record.type_problem == 6 ? ( // อื่นๆ
                  <span>{record.detail_problem}</span>
                ) : (
                  <span>{record.type_problem_name}</span>
                )}
              </div>
            ),
          };
        },
      },
      {
        title: (
          // รายละเอียดเพิ่มเติม
          <LangContext.Consumer>
            {(i18n) => i18n.m.moreDetails}
          </LangContext.Consumer>
        ),
        key: "comment",
        dataIndex: "comment",
        sorter: false,
        width: 300,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          // วันเวลาปฏิบัติงาน
          <LangContext.Consumer>
            {(i18n) => i18n.w.work_date}
          </LangContext.Consumer>
        ),
        key: "work_date",
        dataIndex: "work_date",
        sorter: true,
        width: 150,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          // การแก้ไขปัญหา
          <LangContext.Consumer>
            {(i18n) => i18n.e.editProblem}
          </LangContext.Consumer>
        ),
        key: "edit_problem",
        dataIndex: "edit_problem",
        sorter: false,
        width: 300,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>
                {record.edit_problem.map((item, index) => {
                  return (
                    <div key={index}>
                      {item.edit_problem_id == 21 ? ( //อิื่นๆ
                        <span>{`-${item.detail_amount_devicecode || ""}`}</span>
                      ) : (
                        <span>{`-${item.master_name} ${item.detail_amount_devicecode}`}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            ),
          };
        },
      },
      {
        //ชื่อผู้ยื่นเรื่อง
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.s.submit_name}
          </LangContext.Consumer>
        ),
        key: "submit_name",
        dataIndex: "submit_name",
        width: 200,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        //ประวัติการเลื่อนนัด
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.r.rescheduleLog}
          </LangContext.Consumer>
        ),
        key: "reschedule_log",
        dataIndex: "reschedule_log",
        width: 130,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <Button
                size="small"
                onClick={() => {
                  self.handleOpenRescheduleLog(record.reschedule_log || []);
                }}
                type="link"
                style={{
                  fontSize: "12px",
                  padding: "0px",
                }}
                disabled={record.reschedule_log.length == 0}
              >
                <LangContext.Consumer>
                  {(i18n) => i18n.r.rescheduleLog}
                </LangContext.Consumer>
              </Button>
            ),
          };
        },
      },
      {
        //ชื่อช่าง
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.t.technician_name}
          </LangContext.Consumer>
        ),
        key: "technician_name",
        dataIndex: "technician_name",
        width: 120,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        //เบอร์โทรช่าง
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.t.technician_telno}
          </LangContext.Consumer>
        ),
        key: "technician_telno",
        dataIndex: "technician_telno",
        width: 120,
        sorter: false,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
    ];

    return (
      <div>
        <GeneralStyledContent>
          <Row gutter={24}>
            <Col span={24}>
              <Breadcrumb
                match={this.props.match}
                style={{ margin: "0px 0px 14px 10px" }}
              />
            </Col>
          </Row>
          <Row gutter={24} type="flex" justify="end" style={{ height: "38px" }}>
            <Col span={22}></Col>

            {/* <Col span={2} align="right">
              <Button icon="filter" size="small" onClick={this.showDrawer}>
                <LangContext.Consumer>
                  {(i18n) => i18n.f.filter}
                </LangContext.Consumer>
              </Button>
            </Col> */}
          </Row>
          <Table
            bordered
            size="small"
            columns={columns}
            rowKey={(record) =>
              record.installation_maintenance_devices_detail_id
            }
            dataSource={
              this.props.servicerepairdevice.historyservicerepairdeviceLists
            }
            pagination={{
              pageSize: this.state.pageSize,
              total: this.props.servicerepairdevice
                .historyservicerepairdeviceTotal,
              current: this.state.page,
            }}
            loading={
              this.props.servicerepairdevice.historyservicerepairdeviceLoading
            }
            expandedRowRender={this.expandedRowRender}
            expandIcon={({ expanded, onExpand, record }) => {
              // ❗ ไม่แสดงไอคอน ถ้าแถวนี้ไม่มี children ของตัวเอง (คือเป็นลูกของแถวอื่น)
              if (record.is_child) return null;

              return (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    onExpand(record, e);
                  }}
                >
                  {expanded ? <Icon type="down" /> : <Icon type="right" />}
                </span>
              );
            }}
            onChange={this.handleTableChange}
            scroll={{ x: 1500 }}
          />

          <div>
            <LangContext.Consumer>
              {(i18n) => (
                <Drawer
                  title={i18n.s.search}
                  width={350}
                  onClose={this.onCloseSearch}
                  visible={this.state.visible}
                >
                  <FilterHistory
                    OnClose={this.onCloseSearch}
                    onSubmit={this.filterHistoryservicerepairdevice}
                    loadMaintenancestatus={this.props.loadMaintenancestatus}
                    maintenancestatusLists={
                      this.props.servicerepairdevice.maintenancestatusLists
                    }
                    vehicleLists={this.props.servicerepairdevice.vehicleLists}
                    loadVehicle={this.props.loadVehicle}
                    vehicle_id={this.props.match.params.id}
                  />
                </Drawer>
              )}
            </LangContext.Consumer>
          </div>

          {/* modal แสดงประวัติการเลื่อนนัด */}
          <RescheduleLog
            visible={this.state.rescheduleLogVisible}
            handleModalCancel={this.handleCloseRescheduleLog}
            data={this.state.rescheduleLogData}
          />
        </GeneralStyledContent>
      </div>
    );
  }
}

const mapStateToProps = ({ servicerepairdevice, auth: { profile } }) => ({
  servicerepairdevice,
  profile,
});

const mapDispatchToProps = {
  loadHistoryservicerepairdevice:
    actions.loadHistoryservicerepairdevice.request,
  loadMaintenancestatus: actions.loadMaintenancestatus.request,
  loadVehicle: actions.loadVehicle.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(History);
